(function () {
  if (window.__newProductCardInit) return;
  window.__newProductCardInit = true;

  function withVariantUrl(href, variantId) {
    if (!href || !variantId) return href;
    try {
      var url = new URL(href, window.location.origin);
      url.searchParams.set('variant', String(variantId));
      return url.pathname + url.search + url.hash;
    } catch (e) {
      return href;
    }
  }

  function setActiveSwatch(card, swatch) {
    card.querySelectorAll('[data-product-card-swatch]').forEach(function (btn) {
      btn.classList.remove('is--active');
      btn.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('is--active');
    swatch.setAttribute('aria-pressed', 'true');
  }

  function updateCover(card, swatch) {
    var cover = card.querySelector('[data-new-product-card-cover]');
    if (!cover) return;

    var src = swatch.getAttribute('data-image-src');
    var srcset = swatch.getAttribute('data-image-srcset');
    if (!src) return;

    cover.querySelectorAll('img').forEach(function (img) {
      if (srcset) {
        img.srcset = srcset;
        img.setAttribute('srcset', srcset);
      } else {
        img.removeAttribute('srcset');
        img.srcset = '';
      }
      img.src = src;
      img.setAttribute('src', src);
      img.loading = 'eager';
      img.classList.remove('lazyloadt4s', 'lazyloadt4s--done');
    });

    cover.querySelectorAll('picture source').forEach(function (source) {
      if (srcset) {
        source.setAttribute('srcset', srcset);
      } else if (src) {
        source.setAttribute('srcset', src);
      }
    });
  }

  function syncAtcButton(card, variantId, activeSwatch) {
    var atcBtn = card.querySelector('[data-action-atc]');
    if (!atcBtn) return;

    var textEl = atcBtn.querySelector('.atc-price-btn__text');
    var addLabel = atcBtn.getAttribute('data-label-add-to-cart') || 'Add to cart';
    var soldLabel = atcBtn.getAttribute('data-label-sold-out') || 'Sold out';
    var isSoldOut = activeSwatch && activeSwatch.classList.contains('is--soldout');

    if (variantId) {
      atcBtn.setAttribute('data-variant-id', variantId);
    }

    if (isSoldOut) {
      atcBtn.setAttribute('disabled', 'disabled');
      atcBtn.setAttribute('aria-disabled', 'true');
      atcBtn.setAttribute('aria-label', soldLabel);
      if (textEl) textEl.textContent = soldLabel;
      return;
    }

    atcBtn.removeAttribute('disabled');
    atcBtn.removeAttribute('aria-disabled');
    atcBtn.setAttribute('aria-label', addLabel);
    if (textEl) textEl.textContent = addLabel;
  }

  function syncCardLinks(card, variantId) {
    var mediaLink = card.querySelector('a.new-product-card__media-link');
    if (mediaLink && variantId) {
      mediaLink.setAttribute('href', withVariantUrl(mediaLink.getAttribute('href'), variantId));
    }

    var titleLink = card.querySelector('a.new-product-card__title-link');
    if (titleLink && variantId) {
      titleLink.setAttribute('href', withVariantUrl(titleLink.getAttribute('href'), variantId));
    }

    var activeSwatch = card.querySelector('[data-product-card-swatch].is--active');
    syncAtcButton(card, variantId, activeSwatch);
  }

  function applySwatch(card, swatch) {
    if (!card || !swatch) return;
    setActiveSwatch(card, swatch);
    updateCover(card, swatch);
    syncCardLinks(card, swatch.getAttribute('data-variant-id'));
  }

  function initCardCovers(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = root && root.matches && root.matches('.new-product-card') ? [root] : scope.querySelectorAll('.new-product-card');
    cards.forEach(function (card) {
      var active = card.querySelector('[data-product-card-swatch].is--active');
      if (active) applySwatch(card, active);
    });
  }

  function onSwatchMoreClick(event) {
    var moreBtn = event.target.closest('[data-product-card-swatch-more]');
    if (!moreBtn) return;

    event.preventDefault();
    event.stopPropagation();

    var wrap = moreBtn.closest('[data-product-card-swatches]');
    if (!wrap) return;

    wrap.classList.add('is--expanded');
    moreBtn.setAttribute('aria-expanded', 'true');
  }

  function onSwatchClick(event) {
    var swatch = event.target.closest('[data-product-card-swatch]');
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();

    var card = swatch.closest('.new-product-card');
    if (!card) return;

    applySwatch(card, swatch);
  }

  document.addEventListener('click', onSwatchClick, true);
  document.addEventListener('click', onSwatchMoreClick, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCardCovers();
    });
  } else {
    initCardCovers();
  }

  window.drexeyInitProductCardCovers = initCardCovers;
})();
